<template>
  <div class="approval-page">
    <div class="record-top">
      <div class="date-filter">
        <div class="date-row">
          <span class="date-label">时间</span>
          <span class="date-value" @click="openDateRangePicker">{{ dateRange.start || "开始日期" }}</span>
          <span class="date-sep">-</span>
          <span class="date-value" @click="openDateRangePicker">{{ dateRange.end || "结束日期" }}</span>
          <span v-if="dateRange.start || dateRange.end" class="date-clear" @click="clearDateRange">清空</span>
        </div>
      </div>
      <div class="type-tabs record-filters">
        <van-tabs v-model="listType" swipeable @change="onListTypeChange">
          <van-tab v-for="opt in listTypeOptions" :key="String(opt.value)" :title="opt.label" :name="opt.value" />
        </van-tabs>
      </div>
      <div v-if="isSubmittedTab" class="record-filters">
        <van-tabs v-model="currentStatus" swipeable @change="onStatusChange">
          <van-tab v-for="tab in statusTabs" :key="String(tab.value)" :title="tab.label" :name="tab.value" />
        </van-tabs>
      </div>
    </div>

    <div class="approval-list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :error.sync="loadError"
          error-text="加载失败，点击重试"
          @load="onLoad"
        >
          <div class="records-wrap">
            <van-empty
              v-if="items.length === 0 && !loading && !loadError"
              image="search"
              :description="listEmptyText"
              class="empty"
            />
            <div
              v-for="item in items"
              :key="item.id"
              :class="['record-card', 'record-accent-card', cardStatusClass(item.status)]"
            >
              <div class="record-card-head">
                <span class="record-card-title">{{ item.studentName || "-" }}</span>
                <van-tag :class="['status-tag', statusClass(item)]">{{ statusText(item) }}</van-tag>
              </div>
              <div class="record-row">
                <span class="record-label">中心</span>
                <span class="record-value">{{ item.topDepartmentName || "-" }}</span>
              </div>
              <div class="record-row">
                <span class="record-label">收入类型</span>
                <span class="record-value">{{ item.incomeTypeName || "-" }}</span>
              </div>
              <div class="record-row">
                <span class="record-label">处理类型</span>
                <span class="record-value">{{ item.typeName || refundTypeText(item.type) }}</span>
              </div>
              <div class="record-row">
                <span class="record-label">剩余课费</span>
                <span class="record-value amount">{{ formatAmount(item.balanceFee) }}</span>
              </div>
              <div class="record-row">
                <span class="record-label">手续费</span>
                <span class="record-value">{{ formatAmount(item.serviceFee) }}</span>
              </div>
              <div class="record-row">
                <span class="record-label">实际退费</span>
                <span class="record-value amount">{{ formatAmount(item.actualFee) }}</span>
              </div>
              <div class="record-row">
                <span class="record-label">申请人</span>
                <span class="record-value">{{ item.applyName || "-" }}</span>
              </div>
              <div class="record-row">
                <span class="record-label">申请时间</span>
                <span class="record-value">{{ item.createTime || "-" }}</span>
              </div>
              <div v-if="item.chargeStatusName" class="record-row">
                <span class="record-label">挂账状态</span>
                <span class="record-value">{{ item.chargeStatusName }}</span>
              </div>
              <div v-if="item.remark" class="record-row">
                <span class="record-label">备注</span>
                <span class="record-value">{{ item.remark }}</span>
              </div>

              <div v-if="normalizeList(item.coursePackageList).length" class="collapse-section">
                <div class="collapse-head" @click="toggleSectionExpand(item.id, 'coursePackage')">
                  <span class="collapse-title">课包明细</span>
                  <div class="collapse-head-right">
                    <span v-if="!isSectionExpanded(item.id, 'coursePackage')" class="collapse-summary">
                      {{ normalizeList(item.coursePackageList).length }} 条
                    </span>
                    <van-icon :name="isSectionExpanded(item.id, 'coursePackage') ? 'arrow-up' : 'arrow-down'" class="collapse-arrow" />
                  </div>
                </div>
                <div v-show="isSectionExpanded(item.id, 'coursePackage')" class="collapse-body">
                  <div
                    v-for="(pkg, idx) in normalizeList(item.coursePackageList)"
                    :key="`pkg-${item.id}-${idx}`"
                    class="detail-item-card"
                  >
                    <div class="record-row">
                      <span class="record-label">课包名称</span>
                      <span class="record-value">{{ pkg.coursePackageName || "-" }}</span>
                    </div>
                    <div class="record-row">
                      <span class="record-label">老师</span>
                      <span class="record-value">{{ pkg.teacherName || "-" }}</span>
                    </div>
                    <div class="record-row">
                      <span class="record-label">申请退款课时</span>
                      <span class="record-value">{{ pkg.courseNum != null ? pkg.courseNum : "-" }}</span>
                    </div>
                    <div class="record-row">
                      <span class="record-label">申请退款金额</span>
                      <span class="record-value amount">{{ formatAmount(pkg.courseAmount) }}</span>
                    </div>
                    <div v-if="pkg.statusName" class="record-row">
                      <span class="record-label">状态</span>
                      <span class="record-value">{{ pkg.statusName }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="normalizeList(item.refundDetail).length" class="collapse-section">
                <div class="collapse-head" @click="toggleSectionExpand(item.id, 'refundDetail')">
                  <span class="collapse-title">退费详情</span>
                  <div class="collapse-head-right">
                    <van-icon :name="isSectionExpanded(item.id, 'refundDetail') ? 'arrow-up' : 'arrow-down'" class="collapse-arrow" />
                  </div>
                </div>
                <div v-show="isSectionExpanded(item.id, 'refundDetail')" class="collapse-body">
                  <div
                    v-for="(detail, idx) in normalizeList(item.refundDetail)"
                    :key="`detail-${item.id}-${idx}`"
                    class="detail-item-card"
                  >
                    <div class="record-row">
                      <span class="record-label">退费原因</span>
                      <span class="record-value">{{ detail.remark || "-" }}</span>
                    </div>
                    <div class="record-row image-row">
                      <span class="record-label">剩余课时截图</span>
                      <div class="image-thumb-list">
                        <img
                          v-for="(url, imgIdx) in imageUrls(detail.balanceClassImage)"
                          :key="`class-${item.id}-${idx}-${imgIdx}`"
                          :src="url"
                          class="image-thumb"
                          @click="previewImages(imageUrls(detail.balanceClassImage), imgIdx)"
                        />
                        <span v-if="!imageUrls(detail.balanceClassImage).length" class="record-value">-</span>
                      </div>
                    </div>
                    <div class="record-row image-row">
                      <span class="record-label">剩余价值截图</span>
                      <div class="image-thumb-list">
                        <img
                          v-for="(url, imgIdx) in imageUrls(detail.balanceFeeImage)"
                          :key="`fee-${item.id}-${idx}-${imgIdx}`"
                          :src="url"
                          class="image-thumb"
                          @click="previewImages(imageUrls(detail.balanceFeeImage), imgIdx)"
                        />
                        <span v-if="!imageUrls(detail.balanceFeeImage).length" class="record-value">-</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="normalizeList(item.refundAccount).length" class="collapse-section">
                <div class="collapse-head" @click="toggleSectionExpand(item.id, 'refundAccount')">
                  <span class="collapse-title">收款账户</span>
                  <div class="collapse-head-right">
                    <van-icon :name="isSectionExpanded(item.id, 'refundAccount') ? 'arrow-up' : 'arrow-down'" class="collapse-arrow" />
                  </div>
                </div>
                <div v-show="isSectionExpanded(item.id, 'refundAccount')" class="collapse-body">
                  <div
                    v-for="(acc, idx) in normalizeList(item.refundAccount)"
                    :key="`acc-${item.id}-${idx}`"
                    class="detail-item-card"
                  >
                    <div class="record-row">
                      <span class="record-label">账户姓名</span>
                      <span class="record-value">{{ acc.accountName || "-" }}</span>
                    </div>
                    <div class="record-row">
                      <span class="record-label">银行</span>
                      <span class="record-value">{{ acc.bankName || "-" }}</span>
                    </div>
                    <div class="record-row">
                      <span class="record-label">支行</span>
                      <span class="record-value">{{ acc.bankBranchName || "-" }}</span>
                    </div>
                    <div class="record-row">
                      <span class="record-label">银行卡号</span>
                      <span class="record-value">{{ acc.bankNumber || "-" }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="normalizeRefundBear(item.refundBear).length" class="collapse-section">
                <div class="collapse-head" @click="toggleSectionExpand(item.id, 'refundBear')">
                  <span class="collapse-title">业绩承担</span>
                  <div class="collapse-head-right">
                    <span v-if="!isSectionExpanded(item.id, 'refundBear')" class="collapse-summary">
                      {{ refundBearSummary(item) }}
                    </span>
                    <van-icon :name="isSectionExpanded(item.id, 'refundBear') ? 'arrow-up' : 'arrow-down'" class="collapse-arrow" />
                  </div>
                </div>
                <div v-show="isSectionExpanded(item.id, 'refundBear')" class="collapse-body">
                  <div
                    v-for="(bear, idx) in normalizeRefundBear(item.refundBear)"
                    :key="`bear-${item.id}-${idx}`"
                    class="detail-item-card"
                  >
                    <div class="record-row">
                      <span class="record-label">CC</span>
                      <span class="record-value">{{ bear.ccName || "-" }} / {{ formatAmount(bear.ccFee) }}</span>
                    </div>
                    <div class="record-row">
                      <span class="record-label">SA</span>
                      <span class="record-value">{{ bear.saName || "-" }} / {{ formatAmount(bear.saFee) }}</span>
                    </div>
                    <div v-if="bear.remark" class="record-row">
                      <span class="record-label">说明</span>
                      <span class="record-value">{{ bear.remark }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="visibleApprovalSteps(item.approvalDetailList).length" class="collapse-section approval-detail-block">
                <div class="collapse-head" @click="toggleSectionExpand(item.id, 'approval')">
                  <span class="collapse-title">审批进度</span>
                  <div class="collapse-head-right">
                    <span v-if="!isSectionExpanded(item.id, 'approval')" class="collapse-summary">
                      {{ visibleApprovalSteps(item.approvalDetailList).length }} 人
                    </span>
                    <van-icon :name="isSectionExpanded(item.id, 'approval') ? 'arrow-up' : 'arrow-down'" class="collapse-arrow" />
                  </div>
                </div>
                <div v-show="isSectionExpanded(item.id, 'approval')" class="collapse-body">
                  <div
                    v-for="(step, stepIdx) in visibleApprovalSteps(item.approvalDetailList)"
                    :key="`approval-${item.id}-${stepIdx}`"
                    :class="['approval-step-card', approvalStepCardClass(step.status)]"
                  >
                    <div class="record-row">
                      <span class="record-label">审批人</span>
                      <span class="record-value">{{ step.approveName || "-" }}</span>
                    </div>
                    <div class="record-row">
                      <span class="record-label">状态</span>
                      <span class="record-value" :class="approvalStepStatusClass(step.status)">
                        {{ approvalDetailStatusText(step.status) }}
                      </span>
                    </div>
                    <div v-if="step.approveTime" class="record-row">
                      <span class="record-label">审批时间</span>
                      <span class="record-value">{{ step.approveTime }}</span>
                    </div>
                    <div v-if="step.remark" class="record-row">
                      <span class="record-label">备注</span>
                      <span class="record-value">{{ step.remark }}</span>
                    </div>
                    <div v-if="imageUrls(step.transferVoucher).length" class="record-row image-row">
                      <span class="record-label">退款凭证</span>
                      <div class="image-thumb-list">
                        <img
                          v-for="(url, imgIdx) in imageUrls(step.transferVoucher)"
                          :key="`voucher-${item.id}-${stepIdx}-${imgIdx}`"
                          :src="url"
                          class="image-thumb"
                          @click="previewImages(imageUrls(step.transferVoucher), imgIdx)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="isSubmittedTab && Number(item.status) === 0" class="record-actions">
                <van-button
                  round
                  block
                  plain
                  type="danger"
                  :loading="cancelingId === String(item.id)"
                  @click="cancelApply(item)"
                >
                  取消申请
                </van-button>
              </div>
              <div v-if="isPendingTab && Number(item.status) === 0" class="audit-actions">
                <van-button
                  round
                  block
                  plain
                  type="danger"
                  class="action-btn action-btn-reject"
                  :loading="rejectingId === String(item.id)"
                  @click="openRejectDialog(item)"
                >
                  拒绝
                </van-button>
                <van-button
                  round
                  block
                  type="primary"
                  class="action-btn action-btn-approve"
                  :loading="approvingId === String(item.id)"
                  @click="openApproveDialog(item)"
                >
                  同意
                </van-button>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <div v-if="isSubmittedTab" class="page-bottom-bar">
      <van-button round block type="primary" class="action-btn-approve" @click="openApplyDialog">
        申请退费
      </van-button>
    </div>

    <!-- 申请退费 -->
    <van-popup v-model="applyDialog.show" position="bottom" round :z-index="popupZIndex.apply" :style="{ height: '88vh' }">
      <div class="detail-popup-inner">
        <div class="popup-head">
          <div class="popup-title">申请退费</div>
          <van-icon name="cross" class="popup-close" @click="closeApplyDialog" />
        </div>
        <div class="popup-scroll">
          <van-form @submit="submitApply">
            <van-field
              readonly
              clickable
              label="关联收入"
              :value="applyIncomeLabel"
              placeholder="请选择可退费收入"
              required
              @click="openIncomePicker"
            />
            <van-field
              readonly
              clickable
              label="处理类型"
              :value="refundTypeText(applyDialog.form.type)"
              placeholder="请选择处理类型"
              required
              @click="refundTypePicker.show = true"
            />
            <van-field v-model.trim="applyDialog.form.balanceFee" label="剩余课费" type="number" placeholder="请输入" required />
            <van-field v-model.trim="applyDialog.form.serviceFee" label="手续费" type="number" placeholder="请输入" />
            <van-field v-model.trim="applyDialog.form.actualFee" label="实际退费" type="number" placeholder="请输入" required />
            <van-field v-model.trim="applyDialog.form.remark" label="备注" type="textarea" rows="2" autosize placeholder="选填" />

            <div v-if="applyDialog.form.coursePackageList.length" class="apply-section-title">课包明细</div>
            <div
              v-for="(pkg, idx) in applyDialog.form.coursePackageList"
              :key="`apply-pkg-${idx}`"
              class="detail-edit-card"
            >
              <div class="apply-section-subtitle">{{ pkg.coursePackageName || `课包${idx + 1}` }}</div>
              <van-field v-model.trim="pkg.courseNum" label="退款课时" type="number" placeholder="请输入" required />
              <van-field v-model.trim="pkg.courseAmount" label="退款金额" type="number" placeholder="请输入" required />
            </div>

            <div class="apply-section-title">退费详情</div>
            <div
              v-for="(detail, idx) in applyDialog.form.refundDetail"
              :key="`apply-detail-${idx}`"
              class="detail-edit-card"
            >
              <van-field v-model.trim="detail.remark" label="退费原因" type="textarea" rows="2" autosize placeholder="请输入" required />
              <div class="apply-section-subtitle">剩余课时截图</div>
              <div class="detail-uploader-wrap">
                <van-uploader
                  v-model="detail.balanceClassImageFiles"
                  multiple
                  :after-read="file => onAfterReadDetailImage(idx, 'balanceClassImageFiles', file)"
                />
              </div>
              <div class="apply-section-subtitle">剩余价值截图</div>
              <div class="detail-uploader-wrap">
                <van-uploader
                  v-model="detail.balanceFeeImageFiles"
                  multiple
                  :after-read="file => onAfterReadDetailImage(idx, 'balanceFeeImageFiles', file)"
                />
              </div>
            </div>

            <div class="apply-section-title">收款账户</div>
            <div
              v-for="(acc, idx) in applyDialog.form.refundAccount"
              :key="`apply-acc-${idx}`"
              class="detail-edit-card"
            >
              <van-field v-model.trim="acc.accountName" label="账户姓名" placeholder="请输入" required />
              <van-field v-model.trim="acc.bankName" label="所属银行" placeholder="请输入" required />
              <van-field v-model.trim="acc.bankBranchName" label="所属支行" placeholder="请输入" />
              <van-field v-model.trim="acc.bankNumber" label="银行卡号" placeholder="请输入" required />
            </div>
          </van-form>
        </div>
        <div class="popup-actions apply-actions">
          <van-button round block class="action-btn action-btn-approve" :loading="applyDialog.submitting" @click="submitApply">
            提交申请
          </van-button>
        </div>
      </div>
    </van-popup>

    <!-- 选择可退费收入 -->
    <van-popup v-model="incomePicker.show" position="bottom" round :z-index="popupZIndex.income" :style="{ height: '70vh' }">
      <div class="student-picker-inner">
        <div class="popup-head">
          <div class="popup-title">选择可退费收入</div>
          <van-icon name="cross" class="popup-close" @click="closeIncomePicker" />
        </div>
        <van-search
          v-model="incomePicker.keyword"
          placeholder="搜索学员姓名"
          shape="round"
          @search="onIncomeSearch"
          @input="onIncomeKeywordInput"
        />
        <div class="student-list-wrap">
          <van-list
            v-model="incomePicker.loading"
            :finished="incomePicker.finished"
            :immediate-check="false"
            finished-text="没有更多了"
            @load="onIncomePickerLoad"
          >
            <van-empty v-if="!incomePicker.loading && !incomePicker.list.length" description="暂无可退费收入" class="panel-empty" />
            <div
              v-for="row in incomePicker.list"
              :key="row.incomingDetailId"
              :class="['student-item', { active: String(applyDialog.form.incomingDetailId) === String(row.incomingDetailId) }]"
              @click="selectIncome(row)"
            >
              <div class="student-item-name">{{ row.studentName || "-" }}</div>
              <div class="student-item-sub">{{ incomePickerCellLabel(row) }}</div>
            </div>
          </van-list>
        </div>
      </div>
    </van-popup>

    <van-dialog
      v-model="rejectDialog.show"
      title="拒绝原因"
      show-cancel-button
      confirm-button-text="确认拒绝"
      cancel-button-text="取消"
      @confirm="submitReject"
    >
      <div class="dialog-body">
        <van-field
          v-model.trim="rejectDialog.reason"
          type="textarea"
          rows="3"
          autosize
          maxlength="200"
          placeholder="请输入拒绝原因（选填）"
        />
      </div>
    </van-dialog>

    <van-popup v-model="approveDialog.show" position="bottom" round :z-index="popupZIndex.approve" :style="{ height: needRefundBearOnApprove ? '88vh' : '72vh' }" @close="closeApproveDialog">
      <div class="approve-popup">
        <div class="popup-head">
          <div class="popup-title">同意审批</div>
          <van-icon name="cross" class="popup-close" @click="closeApproveDialog" />
        </div>
        <div class="popup-scroll">
          <van-field
            readonly
            clickable
            label="退款时间"
            :value="approveDialog.refundTime"
            placeholder="请选择退款时间"
            @click="refundTimePicker.show = true"
          />
          <div class="apply-section-subtitle">退款凭证（选填）</div>
          <div class="uploadWrap" ><van-uploader v-model="approveDialog.transferVoucherFiles" multiple :after-read="onAfterReadTransferVoucher" /></div>

          <template v-if="needRefundBearOnApprove">
            <div class="apply-section-title">业绩承担</div>
            <van-field
              readonly
              clickable
              label="CC"
              :value="approveDialog.refundBearForm.ccName"
              placeholder="请选择CC"
              required
              @click="openApproveStaffPicker('cc')"
            />
            <van-field
              v-model.trim="approveDialog.refundBearForm.ccFee"
              label="CC承担金额"
              type="number"
              placeholder="请输入"
              required
            />
            <van-field
              readonly
              clickable
              label="SA"
              :value="approveDialog.refundBearForm.saName"
              placeholder="请选择SA"
              required
              @click="openApproveStaffPicker('sa')"
            />
            <van-field
              v-model.trim="approveDialog.refundBearForm.saFee"
              label="SA承担金额"
              type="number"
              placeholder="请输入"
              required
            />
            <van-field
              v-model.trim="approveDialog.refundBearForm.remark"
              label="退费情况说明"
              type="textarea"
              rows="2"
              autosize
              placeholder="请输入"
              required
            />
          </template>
        </div>
        <div class="approve-footer">
          <van-button
            round
            block
            type="primary"
            class="action-btn action-btn-approve"
            :loading="approveDialog.submitting"
            @click="submitApprove"
          >
            确认同意
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-calendar
      v-model="dateRangePickerShow"
      type="range"
      :allow-same-day="true"
      :show-confirm="true"
      :default-date="dateRangePickerDefault"
      :min-date="dateRangePickerMinDate"
      :max-date="dateRangePickerMaxDate"
      color="rgb(242, 124, 52)"
      @close="dateRangePickerShow = false"
      @confirm="onConfirmDateRange"
    />

    <van-popup v-model="refundTimePicker.show" position="bottom" :z-index="popupZIndex.approveTime">
      <van-datetime-picker
        v-model="refundTimePicker.value"
        type="datetime"
        title="选择退款时间"
        :min-date="dateRangePickerMinDate"
        :max-date="dateRangePickerMaxDate"
        @cancel="refundTimePicker.show = false"
        @confirm="onConfirmRefundTime"
      />
    </van-popup>

    <van-popup v-model="refundTypePicker.show" position="bottom" :z-index="popupZIndex.applyType">
      <van-picker
        show-toolbar
        title="选择处理类型"
        :columns="refundTypeOptions"
        @cancel="refundTypePicker.show = false"
        @confirm="onConfirmRefundType"
      />
    </van-popup>

    <van-popup v-model="staffPicker.show" position="bottom" :z-index="popupZIndex.approveStaff">
      <van-search v-model.trim="staffSearch.keyword" placeholder="搜索员工姓名" />
      <van-picker
        show-toolbar
        :title="staffPicker.title || '选择员工'"
        :columns="filteredApproveStaffOptions"
        @confirm="onConfirmApproveStaff"
        @cancel="staffPicker.show = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant"
import { previewImages as openImagePreview } from "@/utils/imagePreview"
import { request } from "@/api/request"
import {
  fetchRefundList,
  fetchRefundApprovalList,
  applyRefund,
  cancelRefundApply,
  approveRefundPass,
  approveRefundReject,
  fetchRefundableIncomeList
} from "@/api/refund"
import { fetchStaffList } from "@/api/customer"
import { ensureCurrentStaffProfile, getCurrentTopDepartmentId } from "@/store/currentStaff"
import { resetPageScrollAfterPaint } from "@/utils/scroll"

const REFUND_TYPE_OPTIONS = [
  { text: "此笔退费直接退钱且扣除业绩", value: 1 },
  { text: "不扣业绩挂账3个月进行转课处理", value: 2 },
  { text: "退押金不扣除业绩", value: 3 }
]

const Z_APPLY_POPUP = 1100
const Z_INCOME_PICKER = 1120
const Z_APPLY_TYPE_PICKER = 1140
const Z_APPROVE_POPUP = 4130
const Z_APPROVE_STAFF_PICKER = 4320
const Z_APPROVE_TIME_PICKER = 4340

function normalizeList(res) {
  if (Array.isArray(res)) return res
  if (Array.isArray(res?.data)) return res.data
  if (Array.isArray(res?.list)) return res.list
  return []
}

function hasRefundBearItem(item) {
  if (!item || typeof item !== "object") return false
  return (
    item.ccId != null ||
    item.saId != null ||
    (item.ccName && String(item.ccName).trim()) ||
    (item.saName && String(item.saName).trim()) ||
    item.ccFee != null ||
    item.saFee != null ||
    (item.remark && String(item.remark).trim())
  )
}

function normalizeRefundBear(value) {
  if (!value) return []
  if (Array.isArray(value)) return value.filter(item => hasRefundBearItem(item))
  if (typeof value === "object") return hasRefundBearItem(value) ? [value] : []
  return []
}

function uploadTosFile(file) {
  const formData = new FormData()
  formData.append("file", file)
  return request.post("/mgm-crm-api/file/tos/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(r => r.data)
}

export default {
  name: "RefundApproval",
  data() {
    const now = new Date()
    return {
      popupZIndex: {
        apply: Z_APPLY_POPUP,
        income: Z_INCOME_PICKER,
        applyType: Z_APPLY_TYPE_PICKER,
        approve: Z_APPROVE_POPUP,
        approveStaff: Z_APPROVE_STAFF_PICKER,
        approveTime: Z_APPROVE_TIME_PICKER
      },
      listType: 1,
      listTypeOptions: [
        { label: "已提交", value: 1 },
        { label: "待处理", value: 2 },
        { label: "已处理", value: 3 }
      ],
      currentStatus: "all",
      statusTabs: [
        { label: "全部", value: "all" },
        { label: "审批中", value: 0 },
        { label: "已同意", value: 1 },
        { label: "已拒绝", value: 2 },
        { label: "已取消", value: 3 }
      ],
      dateRange: { start: "", end: "" },
      dateRangePickerShow: false,
      dateRangePickerMinDate: new Date(1970, 0, 1),
      dateRangePickerMaxDate: new Date(2100, 11, 31),
      items: [],
      loginTopDepartmentId: null,
      loginAuthType: null,
      loginStaffLoading: false,
      staffOptions: [],
      staffSearch: {
        keyword: ""
      },
      page: 1,
      pageSize: 20,
      loading: false,
      finished: false,
      refreshing: false,
      loadError: false,
      scrollToTopAfterLoad: false,
      cancelingId: "",
      rejectingId: "",
      approvingId: "",
      sectionExpanded: {},
      rejectDialog: { show: false, id: "", reason: "" },
      approveDialog: {
        show: false,
        id: "",
        submitting: false,
        refundTime: "",
        transferVoucherFiles: [],
        refundBearForm: {
          ccId: null,
          ccName: "",
          saId: null,
          saName: "",
          ccFee: "",
          saFee: "",
          remark: ""
        }
      },
      staffPicker: {
        show: false,
        title: "",
        target: ""
      },
      staffLoading: false,
      refundTimePicker: { show: false, value: now },
      refundTypePicker: { show: false },
      refundTypeOptions: REFUND_TYPE_OPTIONS,
      applyDialog: {
        show: false,
        submitting: false,
        selectedIncome: null,
        form: {
          incomingDetailId: null,
          type: null,
          balanceFee: "",
          serviceFee: "",
          actualFee: "",
          remark: "",
          coursePackageList: [],
          refundDetail: [{ remark: "", balanceClassImageFiles: [], balanceFeeImageFiles: [] }],
          refundAccount: [{ accountName: "", bankName: "", bankBranchName: "", bankNumber: "" }]
        }
      },
      incomePicker: {
        show: false,
        loading: false,
        requesting: false,
        finished: false,
        page: 1,
        pageSize: 20,
        keyword: "",
        keywordTimer: null,
        list: []
      }
    }
  },
  computed: {
    dateRangePickerDefault() {
      const { start, end } = this.dateRange
      if (!start && !end) return []
      const s = start ? this.parseDateOnly(start) : null
      const e = end ? this.parseDateOnly(end) : null
      if (s && e) return [s, e]
      return s ? [s, s] : []
    },
    isSubmittedTab() {
      return Number(this.listType) === 1
    },
    isPendingTab() {
      return Number(this.listType) === 2
    },
    listEmptyText() {
      if (this.isSubmittedTab) return "暂无数据"
      if (this.isPendingTab) return "暂无待处理数据"
      return "暂无已处理数据"
    },
    applyIncomeLabel() {
      const row = this.applyDialog.selectedIncome
      if (!row) return ""
      return `${row.studentName || "-"} / ${row.incomeTypeName || "-"} / ${this.formatAmount(row.balanceFee)}`
    },
    needRefundBearOnApprove() {
      return Number(this.loginAuthType) === 3
    },
    filteredApproveStaffOptions() {
      const kw = (this.staffSearch.keyword || "").trim()
      if (!kw) return this.staffOptions
      return this.staffOptions.filter(x => String(x.text || "").includes(kw))
    }
  },
  mounted() {
    const qType = String(this.$route?.query?.type || "").trim()
    if (qType === "approval") this.listType = 2
    this.ensureLoginStaffInfo()
    this.onRefresh()
  },
  methods: {
    formatAmount(v) {
      const n = Number(v)
      if (!Number.isFinite(n)) return "-"
      return `￥${n.toFixed(2)}`
    },
    formatDateOnly(d) {
      const p = n => String(n).padStart(2, "0")
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
    },
    formatDateTime(d) {
      const p = n => String(n).padStart(2, "0")
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
    },
    parseDateOnly(v) {
      if (!v) return new Date()
      const d = new Date(String(v).replace(/-/g, "/"))
      return Number.isNaN(d.getTime()) ? new Date() : d
    },
    refundTypeText(v) {
      const opt = REFUND_TYPE_OPTIONS.find(x => String(x.value) === String(v))
      return opt ? opt.text : (v ?? "")
    },
    async ensureLoginStaffInfo() {
      if (this.loginStaffLoading) return !!this.loginTopDepartmentId
      this.loginStaffLoading = true
      try {
        const staff = await ensureCurrentStaffProfile()
        if (staff && staff.authType !== null && staff.authType !== undefined && staff.authType !== "") {
          this.loginAuthType = staff.authType
        }
        const dept = staff?.topDepartment
        const id = typeof dept === "object" ? (dept.weId ?? dept.id ?? dept.topDepartmentId) : dept
        if (id !== null && id !== undefined && id !== "") {
          this.loginTopDepartmentId = id
          return true
        }
        const cachedId = getCurrentTopDepartmentId()
        if (cachedId !== null && cachedId !== undefined && cachedId !== "") {
          this.loginTopDepartmentId = cachedId
          return true
        }
        return false
      } finally {
        this.loginStaffLoading = false
      }
    },
    mapStaffRows(list) {
      return (Array.isArray(list) ? list : [])
        .map(item => ({
          text: item.weName || item.name || item.staffName || "-",
          value: item.id ?? item.weId ?? item.staffId
        }))
        .filter(x => x.value !== null && x.value !== undefined && x.value !== "")
    },
    async ensureStaffOptions() {
      if (this.staffOptions.length || this.staffLoading) return
      this.staffLoading = true
      try {
        const res = await fetchStaffList({ displayStart: 1, displayLength: 500 })
        this.staffOptions = this.mapStaffRows(normalizeList(res))
      } catch (e) {
        this.staffOptions = []
      } finally {
        this.staffLoading = false
      }
    },
    pickOptionFromPicker(values, indexes, options) {
      if (Number.isInteger(indexes) && options[indexes]) return options[indexes]
      if (Array.isArray(indexes) && indexes.length && options[indexes[0]]) return options[indexes[0]]
      if (Array.isArray(values) && values.length) {
        const v = values[0]
        if (v && typeof v === "object" && "value" in v) return v
        return options.find(o => String(o.value) === String(v) || String(o.text) === String(v)) || null
      }
      if (values && typeof values === "object" && "value" in values) return values
      if (values !== undefined && values !== null && values !== "") {
        return options.find(o => String(o.value) === String(values) || String(o.text) === String(values)) || null
      }
      return null
    },
    statusText(item) {
      const s = Number(item?.status)
      const map = { 0: "审批中", 1: "已同意", 2: "已拒绝", 3: "已取消" }
      return item?.statusName || map[s] || "-"
    },
    approvalDetailStatusText(status) {
      const s = Number(status)
      if (s === 0) return "审批中"
      if (s === 1) return "已同意"
      if (s === 2) return "已拒绝"
      return "-"
    },
    approvalStepStatusClass(status) {
      const s = Number(status)
      if (s === 1) return "approval-step-approved"
      if (s === 2) return "approval-step-rejected"
      return "approval-step-pending"
    },
    approvalStepCardClass(status) {
      const s = Number(status)
      if (s === 1) return "approval-step-card-approved"
      if (s === 2) return "approval-step-card-rejected"
      return "approval-step-card-pending"
    },
    visibleApprovalSteps(list) {
      const steps = this.normalizeList(list)
      const result = []
      for (const step of steps) {
        result.push(step)
        if (Number(step?.status) === 2) break
      }
      return result
    },
    itemSectionKey(itemId, section) {
      return `${itemId || "unknown"}-${section}`
    },
    isSectionExpanded(itemId, section) {
      return !!this.sectionExpanded[this.itemSectionKey(itemId, section)]
    },
    toggleSectionExpand(itemId, section) {
      const key = this.itemSectionKey(itemId, section)
      this.$set(this.sectionExpanded, key, !this.sectionExpanded[key])
    },
    statusClass(item) {
      const s = Number(item?.status)
      if (s === 0) return "status-pending"
      if (s === 1) return "status-approved"
      if (s === 2) return "status-rejected"
      return "status-cancel"
    },
    cardStatusClass(status) {
      const s = Number(status)
      if (s === 0) return "card-pending"
      if (s === 1) return "card-approved"
      if (s === 2) return "card-rejected"
      if (s === 3) return "card-cancel"
      return "card-pending"
    },
    onListTypeChange(type) {
      this.listType = Number(type) || 1
      this.onRefresh(true)
    },
    onStatusChange(v) {
      this.currentStatus = v === "all" ? "all" : Number(v)
      this.onRefresh(true)
    },
    openDateRangePicker() {
      this.dateRangePickerShow = true
    },
    onConfirmDateRange(dates) {
      this.dateRangePickerShow = false
      const arr = Array.isArray(dates) ? dates : [dates]
      const start = arr[0]
      const end = arr[1] || arr[0]
      this.dateRange.start = start ? this.formatDateOnly(start) : ""
      this.dateRange.end = end ? this.formatDateOnly(end) : ""
      this.onRefresh()
    },
    clearDateRange() {
      if (!this.dateRange.start && !this.dateRange.end) return
      this.dateRange.start = ""
      this.dateRange.end = ""
      this.onRefresh()
    },
    onRefresh(scrollToTop = false) {
      if (scrollToTop) {
        this.scrollToTopAfterLoad = true
        resetPageScrollAfterPaint(this.$el)
      }
      this.finished = false
      this.loading = true
      this.refreshing = true
      this.page = 1
      this.items = []
      this.onLoad()
    },
    buildListPayload() {
      const payload = {
        createStartTime: this.dateRange.start || undefined,
        createEndTime: this.dateRange.end || undefined,
        displayLength: this.pageSize,
        displayStart: this.page
      }
      const listType = Number(this.listType)
      if (listType === 1) {
        if (this.currentStatus !== "all") payload.status = Number(this.currentStatus)
      } else if (listType === 2) {
        payload.approvalStatusList = [0]
      } else if (listType === 3) {
        payload.approvalStatusList = [1, 2, 3]
      }
      return payload
    },
    async onLoad() {
      this.loadError = false
      try {
        const payload = this.buildListPayload()
        const listType = Number(this.listType)
        const fetchList = listType === 1 ? fetchRefundList : fetchRefundApprovalList
        const res = await fetchList(payload)
        const list = normalizeList(res)
        if (this.refreshing) this.items = []
        this.items = this.items.concat(list)
        this.finished = list.length < this.pageSize
        this.page += 1
      } catch (e) {
        this.loadError = true
      } finally {
        this.loading = false
        this.refreshing = false
        if (this.scrollToTopAfterLoad) {
          this.scrollToTopAfterLoad = false
          this.$nextTick(() => resetPageScrollAfterPaint(this.$el))
        }
      }
    },
    normalizeList(value) {
      return normalizeList(value)
    },
    normalizeRefundBear(value) {
      return normalizeRefundBear(value)
    },
    refundBearSummary(item) {
      const list = normalizeRefundBear(item?.refundBear)
      if (!list.length) return "-"
      return list
        .map(bear => {
          const parts = []
          if (bear.ccName || bear.ccFee != null) {
            parts.push(`CC ${bear.ccName || "-"} ${this.formatAmount(bear.ccFee)}`)
          }
          if (bear.saName || bear.saFee != null) {
            parts.push(`SA ${bear.saName || "-"} ${this.formatAmount(bear.saFee)}`)
          }
          return parts.join("；") || "-"
        })
        .join(" / ")
    },
    imageUrls(value) {
      return this.normalizeList(value)
        .map(x => (typeof x === "string" ? x : x?.tosUrl || ""))
        .filter(Boolean)
    },
    previewImages(urls, startPosition = 0) {
      openImagePreview(urls, startPosition)
    },
    async cancelApply(item) {
      const id = item?.id
      if (!id) return Toast.fail("缺少申请ID")
      try {
        await Dialog.confirm({ message: "确定取消申请?" })
      } catch (e) {
        return
      }
      this.cancelingId = String(id)
      try {
        await cancelRefundApply({ id })
        Toast.success("已取消申请")
        this.onRefresh()
      } finally {
        this.cancelingId = ""
      }
    },
    openRejectDialog(item) {
      const id = item?.id
      if (!id) return Toast.fail("缺少申请ID")
      this.rejectDialog.id = String(id)
      this.rejectDialog.reason = ""
      this.rejectDialog.show = true
    },
    async submitReject() {
      const id = this.rejectDialog.id
      if (!id) return Toast.fail("缺少申请ID")
      this.rejectingId = String(id)
      try {
        await approveRefundReject({ id, rejectReason: (this.rejectDialog.reason || "").trim() })
        Toast.success("已拒绝")
        this.rejectDialog.show = false
        this.onRefresh()
      } finally {
        this.rejectingId = ""
      }
    },
    async openApproveDialog(item) {
      const id = item?.id
      if (!id) return Toast.fail("缺少申请ID")
      await this.ensureLoginStaffInfo()
      this.approveDialog.id = String(id)
      this.approveDialog.refundTime = this.formatDateTime(new Date())
      this.approveDialog.transferVoucherFiles = []
      this.approveDialog.refundBearForm = {
        ccId: null,
        ccName: "",
        saId: null,
        saName: "",
        ccFee: "",
        saFee: "",
        remark: ""
      }
      this.refundTimePicker.value = new Date()
      this.approveDialog.show = true
    },
    closeApproveDialog() {
      this.approveDialog.show = false
    },
    async openApproveStaffPicker(target) {
      await this.ensureStaffOptions()
      if (!this.staffOptions.length) return Toast.fail("暂无员工列表")
      this.staffSearch.keyword = ""
      this.staffPicker.target = target
      this.staffPicker.title = target === "cc" ? "选择CC" : "选择SA"
      this.staffPicker.show = true
    },
    onConfirmApproveStaff(values, indexes) {
      const opt = this.pickOptionFromPicker(values, indexes, this.filteredApproveStaffOptions)
      if (opt) {
        const form = this.approveDialog.refundBearForm
        if (this.staffPicker.target === "cc") {
          form.ccId = opt.value
          form.ccName = opt.text
        } else if (this.staffPicker.target === "sa") {
          form.saId = opt.value
          form.saName = opt.text
        }
      }
      this.staffPicker.show = false
    },
    validateApproveRefundBear() {
      if (!this.needRefundBearOnApprove) return ""
      const form = this.approveDialog.refundBearForm
      if (form.ccId === null || form.ccId === undefined || form.ccId === "") return "请选择CC"
      if (form.saId === null || form.saId === undefined || form.saId === "") return "请选择SA"
      const ccFee = Number(form.ccFee)
      if (form.ccFee === "" || !Number.isFinite(ccFee) || ccFee < 0) return "请输入正确的CC承担金额"
      const saFee = Number(form.saFee)
      if (form.saFee === "" || !Number.isFinite(saFee) || saFee < 0) return "请输入正确的SA承担金额"
      if (!(form.remark || "").trim()) return "请输入退费情况说明"
      return ""
    },
    onConfirmRefundTime(v) {
      this.approveDialog.refundTime = this.formatDateTime(v)
      this.refundTimePicker.show = false
    },
    async submitApprove() {
      const id = this.approveDialog.id
      if (!id) return Toast.fail("缺少申请ID")
      const bearErr = this.validateApproveRefundBear()
      if (bearErr) return Toast.fail(bearErr)
      this.approveDialog.submitting = true
      this.approvingId = String(id)
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        const transferVoucher = this.mapUploaderFiles(this.approveDialog.transferVoucherFiles)
        const payload = { id }
        if (this.approveDialog.refundTime) payload.refundTime = this.approveDialog.refundTime
        if (transferVoucher.length) payload.transferVoucher = transferVoucher
        if (this.needRefundBearOnApprove) {
          const form = this.approveDialog.refundBearForm
          payload.refundBear = [{
            ccId: Number(form.ccId),
            ccFee: Number(form.ccFee),
            saId: Number(form.saId),
            saFee: Number(form.saFee),
            remark: (form.remark || "").trim()
          }]
        }
        await approveRefundPass(payload)
        Toast.clear()
        Toast.success("已同意")
        this.approveDialog.show = false
        this.onRefresh()
      } finally {
        this.approveDialog.submitting = false
        this.approvingId = ""
      }
    },
    mapUploaderFiles(fileList) {
      const list = Array.isArray(fileList) ? fileList : []
      return list.map(file => {
        const uploaded = file?.uploadMeta
        const url = uploaded?.tosUrl || file?.url || file?.content || ""
        const name = uploaded?.name || file?.file?.name || file?.name || ""
        const tosName = uploaded?.tosName || file?.tosName || ""
        return { name, tosName, tosUrl: url }
      }).filter(x => x.tosUrl)
    },
    async onAfterReadTransferVoucher(file) {
      await this.handleUploaderRead(this.approveDialog.transferVoucherFiles, file)
    },
    async onAfterReadDetailImage(detailIdx, fieldKey, file) {
      const detail = this.applyDialog.form.refundDetail[detailIdx]
      if (!detail) return
      await this.handleUploaderRead(detail[fieldKey], file)
    },
    async handleUploaderRead(fieldList, file) {
      const files = Array.isArray(file) ? file : [file]
      for (const item of files) {
        const rawFile = item?.file
        if (!rawFile) continue
        item.status = "uploading"
        item.message = "上传中..."
        try {
          const uploaded = await uploadTosFile(rawFile)
          item.status = "done"
          item.message = ""
          item.url = uploaded?.tosUrl || item.url || item.content || ""
          item.uploadMeta = {
            name: uploaded?.name || rawFile?.name || "",
            tosName: uploaded?.tosName || "",
            tosUrl: uploaded?.tosUrl || ""
          }
        } catch (e) {
          item.status = "failed"
          item.message = "上传失败"
        }
      }
    },
    async openApplyDialog() {
      const staffOk = await this.ensureLoginStaffInfo()
      if (!staffOk || !this.loginTopDepartmentId) return Toast.fail("未获取到中心ID")
      this.applyDialog.selectedIncome = null
      this.applyDialog.form = {
        incomingDetailId: null,
        type: null,
        balanceFee: "",
        serviceFee: "",
        actualFee: "",
        remark: "",
        coursePackageList: [],
        refundDetail: [{ remark: "", balanceClassImageFiles: [], balanceFeeImageFiles: [] }],
        refundAccount: [{ accountName: "", bankName: "", bankBranchName: "", bankNumber: "" }]
      }
      this.applyDialog.show = true
    },
    closeApplyDialog() {
      this.applyDialog.show = false
    },
    openIncomePicker() {
      this.incomePicker.keyword = ""
      this.incomePicker.page = 1
      this.incomePicker.finished = false
      this.incomePicker.list = []
      this.incomePicker.show = true
      this.loadRefundableIncome(true)
    },
    closeIncomePicker() {
      this.incomePicker.keyword = ""
      this.incomePicker.show = false
    },
    onIncomeKeywordInput() {
      if (this.incomePicker.keywordTimer) clearTimeout(this.incomePicker.keywordTimer)
      this.incomePicker.keywordTimer = setTimeout(() => {
        this.loadRefundableIncome(true)
      }, 350)
    },
    onIncomeSearch() {
      this.loadRefundableIncome(true)
    },
    onIncomePickerLoad() {
      this.loadRefundableIncome(false)
    },
    incomePickerCellLabel(row) {
      const parts = [
        row.incomeTypeName || "-",
        row.incomeTime || "-",
        `可退 ${this.formatAmount(row.balanceFee)}`
      ]
      return parts.join(" · ")
    },
    async loadRefundableIncome(reset = false) {
      if (reset) {
        this.incomePicker.page = 1
        this.incomePicker.finished = false
        this.incomePicker.list = []
      }
      if (this.incomePicker.requesting || this.incomePicker.finished) {
        this.incomePicker.loading = false
        return
      }
      this.incomePicker.loading = true
      this.incomePicker.requesting = true
      try {
        const payload = {
          displayStart: this.incomePicker.page,
          displayLength: this.incomePicker.pageSize,
          topDepartmentId: this.loginTopDepartmentId || undefined,
          stuName: (this.incomePicker.keyword || "").trim() || undefined
        }
        const res = await fetchRefundableIncomeList(payload)
        const list = normalizeList(res)
        this.incomePicker.list = this.incomePicker.list.concat(list)
        this.incomePicker.finished = list.length < this.incomePicker.pageSize
        if (!this.incomePicker.finished) this.incomePicker.page += 1
      } catch (e) {
        if (reset) this.incomePicker.list = []
      } finally {
        this.incomePicker.requesting = false
        this.incomePicker.loading = false
      }
    },
    selectIncome(row) {
      if (!row?.incomingDetailId) return Toast.fail("收入数据无效")
      this.applyDialog.selectedIncome = row
      this.applyDialog.form.incomingDetailId = row.incomingDetailId
      this.applyDialog.form.balanceFee = ""
      this.applyDialog.form.serviceFee = ""
      this.applyDialog.form.actualFee = ""
      const pkgList = normalizeList(row.coursePackageList)
      this.applyDialog.form.coursePackageList = pkgList.map(pkg => ({
        orderCoursePackageId: pkg.orderCoursePackageId ?? pkg.id,
        coursePackageName: pkg.coursePackageName || "",
        courseNum: pkg.remainTransferNum != null ? String(pkg.remainTransferNum) : "",
        courseAmount: pkg.remainTransferAmount != null ? String(pkg.remainTransferAmount) : ""
      }))
      this.incomePicker.show = false
    },
    onConfirmRefundType(values, indexes) {
      const idx = Array.isArray(indexes) ? indexes[0] : indexes
      const opt = REFUND_TYPE_OPTIONS[idx]
      if (opt) this.applyDialog.form.type = opt.value
      this.refundTypePicker.show = false
    },
    validateApplyForm() {
      const form = this.applyDialog.form
      if (!form.incomingDetailId) return "请选择可退费收入"
      if (form.type === null || form.type === undefined || form.type === "") return "请选择处理类型"
      if (form.balanceFee === "" || form.balanceFee === null || form.balanceFee === undefined) {
        return "请输入剩余课费"
      }
      const balanceFee = Number(form.balanceFee)
      if (!Number.isFinite(balanceFee) || balanceFee < 0) return "请输入正确的剩余课费"
      if (form.actualFee === "" || form.actualFee === null || form.actualFee === undefined) {
        return "请输入实际退费"
      }
      const actualFee = Number(form.actualFee)
      if (!Number.isFinite(actualFee) || actualFee < 0) return "请输入正确的实际退费"
      const pkgList = Array.isArray(form.coursePackageList) ? form.coursePackageList : []
      for (let i = 0; i < pkgList.length; i++) {
        const pkg = pkgList[i]
        const n = i + 1
        const name = (pkg.coursePackageName || "").trim() || `第${n}个课包`
        const courseNum = Number(pkg.courseNum)
        if (pkg.courseNum === "" || pkg.courseNum === null || pkg.courseNum === undefined) {
          return `${name}：请输入退款课时`
        }
        if (!Number.isFinite(courseNum) || courseNum < 0) return `${name}：请输入正确的退款课时`
        const courseAmount = Number(pkg.courseAmount)
        if (pkg.courseAmount === "" || pkg.courseAmount === null || pkg.courseAmount === undefined) {
          return `${name}：请输入退款金额`
        }
        if (!Number.isFinite(courseAmount) || courseAmount < 0) return `${name}：请输入正确的退款金额`
      }
      const detail = form.refundDetail[0]
      if (!(detail?.remark || "").trim()) return "请输入退费原因"
      const acc = form.refundAccount[0]
      if (!(acc?.accountName || "").trim()) return "请输入账户姓名"
      if (!(acc?.bankName || "").trim()) return "请输入所属银行"
      if (!(acc?.bankNumber || "").trim()) return "请输入银行卡号"
      return ""
    },
    async submitApply() {
      const err = this.validateApplyForm()
      if (err) return Toast.fail(err)
      const form = this.applyDialog.form
      const detail = form.refundDetail[0]
      const acc = form.refundAccount[0]
      const payload = {
        incomingDetailId: form.incomingDetailId,
        type: Number(form.type),
        balanceFee: Number(form.balanceFee),
        serviceFee: form.serviceFee !== "" ? Number(form.serviceFee) : undefined,
        actualFee: Number(form.actualFee),
        remark: (form.remark || "").trim() || undefined,
        refundDetail: [{
          remark: (detail.remark || "").trim(),
          balanceClassImage: this.mapUploaderFiles(detail.balanceClassImageFiles),
          balanceFeeImage: this.mapUploaderFiles(detail.balanceFeeImageFiles)
        }],
        refundAccount: [{
          accountName: (acc.accountName || "").trim(),
          bankName: (acc.bankName || "").trim(),
          bankBranchName: (acc.bankBranchName || "").trim() || undefined,
          bankNumber: (acc.bankNumber || "").trim()
        }]
      }
      if (form.coursePackageList.length) {
        payload.coursePackageList = form.coursePackageList.map(pkg => ({
          orderCoursePackageId: pkg.orderCoursePackageId,
          courseNum: Number(pkg.courseNum),
          courseAmount: Number(pkg.courseAmount)
        }))
      }
      this.applyDialog.submitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await applyRefund(payload)
        Toast.clear()
        Toast.success("申请成功")
        this.applyDialog.show = false
        this.onRefresh()
      } finally {
        this.applyDialog.submitting = false
      }
    }
  }
}
</script>

<style src="@/styles/approval-status.css"></style>
<style scoped>
.approval-page {
  min-height: 100vh;
  background: #f7f8fa;
  display: flex;
  flex-direction: column;
}

.record-top {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  padding-top: 4px;
}

.date-filter {
  padding: 0 12px 4px;
  background: #fff;
}

.date-row {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  padding: 0 2px;
}

.date-label {
  font-size: 13px;
  color: #969799;
  flex: 0 0 auto;
}

.date-value {
  font-size: 13px;
  color: #323233;
  padding: 1px 5px;
  border-radius: 6px;
  background: #f7f8fa;
}

.date-sep {
  color: #969799;
}

.date-clear {
  margin-left: 6px;
  font-size: 12px;
  color: rgb(242, 124, 52);
}

.record-filters {
  background: #fff;
}

:deep(.van-tab--active) {
  color: rgb(242, 124, 52);
}

:deep(.van-tabs__line) {
  background: rgb(242, 124, 52);
}

:deep(.van-tabs__wrap) {
  height: 34px;
}

.approval-list {
  flex: 1;
  padding: 8px 12px calc(80px + var(--app-safe-area-bottom, 0px));
}

.records-wrap {
  min-height: 120px;
}

.record-card {
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.record-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.record-card-title {
  font-size: 15px;
  font-weight: 600;
  color: #323233;
}

.record-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 4px 0;
  font-size: 13px;
}

.record-label {
  color: #969799;
  flex-shrink: 0;
}

.record-value {
  color: #323233;
  text-align: right;
  word-break: break-all;
}

.record-value.amount {
  color: rgb(242, 124, 52);
  font-weight: 600;
}

.audit-actions,
.record-actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.page-bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: var(--app-tabbar-offset, 50px);
  padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.06);
  z-index: 90;
}

.action-btn-approve {
  color: #fff;
  background: rgb(242, 124, 52);
  border-color: rgb(242, 124, 52);
}

.detail-popup-inner,
.approve-popup {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.popup-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #ebedf0;
}

.popup-title {
  font-size: 16px;
  font-weight: 600;
}

.popup-close {
  font-size: 18px;
  color: #969799;
}

.popup-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.collapse-section {
  margin-top: 10px;
  border-top: 1px dashed #f0f0f0;
  padding-top: 8px;
}

.collapse-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.collapse-title {
  font-size: 13px;
  font-weight: 600;
  color: #323233;
}

.collapse-head-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.collapse-summary {
  font-size: 12px;
  color: #969799;
}

.collapse-arrow {
  color: #969799;
}

.collapse-body {
  margin-top: 8px;
}

.detail-item-card {
  margin-top: 8px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 0 10px 10px;
}

.detail-edit-card {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 8px 10px;
  margin: 0 12px 8px;
}

.apply-section-title {
  margin: 10px 16px 8px;
  font-size: 13px;
  color: #969799;
}

.apply-section-subtitle {
  margin: 0 16px 6px;
  font-size: 13px;
  color: #646566;
}

.uploadWrap {
  padding: 0 16px;
}

.detail-uploader-wrap {
  padding: 0 16px 10px;
}

.popup-actions {
  flex-shrink: 0;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  border-top: 1px solid #ebedf0;
  background: #fff;
}

.approve-footer {
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  border-top: 1px solid #ebedf0;
}

.image-thumb-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.image-thumb {
  width: 44px;
  height: 44px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

.student-picker-inner {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.student-list-wrap {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 12px 8px;
}

.student-item {
  padding: 10px 12px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(30, 35, 90, 0.05);
  margin-bottom: 8px;
}

.student-item.active {
  background: rgba(242, 124, 52, 0.12);
  border: 1px solid rgba(242, 124, 52, 0.35);
}

.student-item-name {
  font-size: 14px;
  font-weight: 700;
  color: #323233;
}

.student-item-sub {
  margin-top: 4px;
  font-size: 12px;
  color: #969799;
}

.panel-loading,
.panel-empty {
  padding: 24px 0;
  text-align: center;
}

.dialog-body {
  padding: 12px 16px 4px;
}
</style>
